<template>
  <div ref="container" style="height:100%;position: relative;overflow-y: auto;">
    <div style="padding: 0px;background-color: #fff">
      <div  class="block" style="padding-top: 0px;padding-bottom: 0px;" >
        <a-tabs v-model:activeKey="tab_activeKey" @change="changeTabPage">
          <a-tab-pane key="woBaseFaultDescManage" tab="故障说明"></a-tab-pane>
          <a-tab-pane key="woBaseFaultTypeManage" tab="故障类型"></a-tab-pane>
          <a-tab-pane key="woBaseTransferOrderTypeManage" tab="转单类型"></a-tab-pane>
        </a-tabs>
      </div>

      <div class="block" style="" >
        <transition mode="out-in" leave-active-class="cmp-out" enter-active-class="cmp-in">
          <Component :is="cmpObj"/>
        </transition>
      </div>


    </div>
  </div>
</template>

<script setup>
import {defineAsyncComponent, ref, shallowRef} from "vue";
/** 异步加载组件 **/
const woBaseFaultDescManage = defineAsyncComponent(() =>{
  return import('@/components/_woBaseFaultDescManage.vue')
})
/** 异步加载组件 **/
const woBaseFaultTypeManage = defineAsyncComponent(() =>{
  return import('@/components/_woBaseFaultTypeManage.vue')
})
/** 异步加载组件 **/
const woBaseTransferOrderTypeManage = defineAsyncComponent(() =>{
  return import('@/components/_woBaseTransferOrderTypeManage.vue')
})

const tab_activeKey = ref("woBaseFaultDescManage");
const cmpObj = shallowRef(woBaseFaultDescManage);

const changeTabPage = ()=>{
  if (tab_activeKey.value === "woBaseFaultDescManage"){
    cmpObj.value = woBaseFaultDescManage;
  }else if(tab_activeKey.value === "woBaseFaultTypeManage"){
    cmpObj.value = woBaseFaultTypeManage;
  }else if(tab_activeKey.value === "woBaseTransferOrderTypeManage"){
    cmpObj.value = woBaseTransferOrderTypeManage;
  }

}

</script>

<style scoped>
.block{
  box-sizing:border-box;
  padding-left: 10px;
  padding-right: 10px;
}
.cmp-in {
  animation: fadeIn;
  animation-duration: 0.2s; /* don't forget to set a duration! */
}
.cmp-out{
  animation: fadeOut;
  animation-duration: 0.2s;
}
</style>
